export function initDeferredVideo() {
    const video = document.querySelector('[data-deferred-video]');

    if (!video) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData === true;

    if (reducedMotion || saveData) {
        return;
    }

    const sources = [...video.querySelectorAll('source[data-src]')];
    let started = false;

    const removeInteractionListeners = () => {
        window.removeEventListener('pointerdown', startVideo);
        window.removeEventListener('keydown', startVideo);
    };

    const startVideo = () => {
        if (started || document.visibilityState === 'hidden') {
            return;
        }

        started = true;
        removeInteractionListeners();

        sources.forEach((source) => {
            source.src = source.dataset.src;
            delete source.dataset.src;
        });

        video.load();
        video.play().catch(() => {});
    };

    const scheduleVideo = () => {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(startVideo, { timeout: 2000 });
            return;
        }

        window.setTimeout(startVideo, 1000);
    };

    window.addEventListener('pointerdown', startVideo, { passive: true });
    window.addEventListener('keydown', startVideo);

    if (document.readyState === 'complete') {
        scheduleVideo();
    } else {
        window.addEventListener('load', scheduleVideo, { once: true });
    }
}
